
import { useState, useEffect } from 'react';
import { User } from '@supabase/supabase-js';
import { toast } from 'sonner';

export const useGuestUsername = (user: User | null) => {
  const [username, setUsername] = useState('');
  const [isUsernameSaved, setIsUsernameSaved] = useState(false);
  
  // Check for saved username in localStorage for guests
  useEffect(() => {
    if (!user) {
      const savedUsername = localStorage.getItem('guestUsername');
      if (savedUsername) {
        setUsername(savedUsername);
        setIsUsernameSaved(true);
      }
    }
  }, [user]);
  
  const handleUsernameSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!username.trim()) {
      toast.error('Please enter your name');
      return;
    }
    
    // Save username to localStorage for future visits
    localStorage.setItem('guestUsername', username.trim());
    setIsUsernameSaved(true);
    toast.success('Name saved successfully');
  };
  
  return {
    username,
    setUsername,
    isUsernameSaved,
    setIsUsernameSaved,
    handleUsernameSubmit
  };
};
